<template>
  <div id="May2024" class="202404 relative">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <!-- <a class="toggle-btn absolute cursor-pointer p-6 block" @click="isMenu = !isMenu">
        <img src="~@/assets/images/202307/menu/right.png" class="object-contain w-full">
      </a> -->
      <a class="block px-3">
        <img src="~@/assets/images/202405/menu/slide-bar-off_01.png" class="object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan1')">
        <img src="~@/assets/images/202405/menu/slide-bar-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202405/menu/slide-bar-on_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan2')">
        <img src="~@/assets/images/202405/menu/slide-bar-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202405/menu/slide-bar-on_03.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan3')">
        <img src="~@/assets/images/202405/menu/slide-bar-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202405/menu/slide-bar-on_04.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan4')">
        <img src="~@/assets/images/202405/menu/slide-bar-off_05.png" class="off object-contain">
        <img src="~@/assets/images/202405/menu/slide-bar-on_05.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan5')">
        <img src="~@/assets/images/202405/menu/slide-bar-off_06.png" class="off object-contain">
        <img src="~@/assets/images/202405/menu/slide-bar-on_06.png" class="on object-contain">
      </a>
    </div>

    <div class="logo bg-main hidden md:block">
      <router-link :to="{ name: 'index' }" class="py-3 block"><img src="~@/assets/images/202405/LiveABC-logo.png" class="object-contain block mx-auto"></router-link>
    </div>

    <div class="banner w-full pt-10 pb-10">
      <div class="container mx-auto md:pt-12 px-4 md:px-0">
        <div class="mb-4 px-4 md:px-0"><img src="~@/assets/images/202405/master-title.png" class="object-contain block mx-auto"></div>
        <div class="mb-6 car"><img src="~@/assets/images/202405/master-car.png" class="object-contain block mx-auto"></div>
        <div class="-mb-24 hidden md:block"><img src="~@/assets/images/202405/menu-bar.png" class="object-contain block mx-auto"></div>
        <div class="flex flex-wrap md:hidden justify-center items-center">
          <div class="p-1"><img src="~@/assets/images/202405/m/BT-01.png" class="object-contain h-10 w-auto"></div>
          <div class="p-1"><img src="~@/assets/images/202405/m/BT-02.png" class="object-contain h-10 w-auto"></div>
          <div class="p-1"><img src="~@/assets/images/202405/m/BT-03.png" class="object-contain h-10 w-auto"></div>
          <div class="p-1"><img src="~@/assets/images/202405/m/BT-04.png" class="object-contain h-10 w-auto"></div>
          <div class="p-1"><img src="~@/assets/images/202405/m/BT-05.png" class="object-contain h-10 w-auto"></div>
        </div>
      </div>
    </div>

    <section class="main mx-auto">
      <div id="plan1" class="plan1 px-2 pb-20 md:pb-32 md:pt-32">
        <div class="container mx-auto">
          <div class="mb-4 -mt-10 md:-mt-0">
            <img src="~@/assets/images/202405/MG-TITLE-01.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/202405/m/MG-TITLE-02.png" class="object-contain mx-auto md:hidden">
          </div>
          <!-- <a href="https://store.liveabc.com/products/magazine/sale?tag=363" target="_blank" class="hidden md:block">
            <img src="~@/assets/images/202405/MG-5MG.png" class="object-contain block mx-auto">
          </a> -->
          <div class="hidden md:block">
            <div class="flex justify-center items-center mb-6">
              <router-link class="p-2" :to="{ name: 'detail', params: { category: 'magazine', id: 7726 } }"><img src="~@/assets/images/202405/m/LIVE-COVER.png" class="object-contain"></router-link>
              <a class="px-2 w-7/12 lg:w-6/12 xl:w-5/12 inline-block" href="https://store.liveabc.com/products/magazine/sale?tag=363" target="_blank"><img src="~@/assets/images/202405/MG-TITLE-02.png" class="object-contain"></a>
            </div>
            <div class="flex w-full justify-center items-center">
              <router-link class="p-2" v-for="(item, index) in planData2" :key="index" :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }">
                <img :src="item.img_url" class="object-contain mx-auto">
              </router-link>
            </div>
          </div>
          <div class="md:hidden">
            <div class="mb-4"><img src="~@/assets/images/202405/m/MG-title-01.png" class="object-contain mx-auto"></div>
            <a href="https://store.liveabc.com/products/magazine/sale?tag=363" target="_blank" class="mb-4 block"><img src="~@/assets/images/202405/m/order-bt.png" class="object-contain mx-auto"></a>
            <div class="flex flex-wrap w-full justify-center">
              <router-link class="p-2" :class="item.class" v-for="(item, index) in planData" :key="index" :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }">
                <img :src="item.img_url" class="object-contain mx-auto">
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <a id="plan2" href="https://store.liveabc.com/products/magazine/sale?tag=367" class="plan2 px-2 pt-6 pb-12 block">
        <div class="container mx-auto">
          <div class="-mt-16 lg:-mt-24">
            <img src="~@/assets/images/202405/MG-HIW-title.png" class="object-contain hidden md:block mx-auto">
            <img src="~@/assets/images/202405/m/MG-HIW-title.png" class="object-contain md:hidden mx-auto">
          </div>
          <div class="mt-8 md:mt-12">
            <img src="~@/assets/images/202405/MG-HIW.png" class="object-contain hidden md:block mx-auto">
            <img src="~@/assets/images/202405/m/MG-HIW-IMAGES.png" class="object-contain md:hidden mx-auto">
          </div>
        </div>
      </a>
      <a id="plan3" href="https://store.liveabc.com/products/magazine/sale?tag=362" class="plan3 px-2 pt-6 pb-12 block">
        <div class="container mx-auto">
          <div class="mb-12 md:mb-0"><img src="~@/assets/images/202405/Line 8.png" class="object-contain block mx-auto"></div>
          <div class="-mt-3">
            <img src="~@/assets/images/202405/LIVEPEN.png" class="object-contain hidden md:block mx-auto">
            <img src="~@/assets/images/202405/m/LIVEPEN.png" class="object-contain md:hidden mx-auto">
          </div>
        </div>
      </a>
      <div id="plan4" class="plan4 px-2 pt-32 py-10">
        <div class="mb-24 hidden md:block"><img src="~@/assets/images/202405/Line 8.png" class="object-contain block mx-auto"></div>

        <div class="plan4_inner container mx-auto py-4 px-2 md:px-6 pb-16">
          <div class="items-end -mt-48 z-30 md:hidden">
            <div><img src="~@/assets/images/202405/book-images-L.png" class="object-contain block mx-auto"></div>
          </div>
          <div class="-mt-16 md:-mt-20"><img src="~@/assets/images/202405/book-title-01.png" class="object-contain block mx-auto"></div>
          <div class="items-end lg:-mt-10 -mb-6 z-30 hidden md:flex">
            <div><img src="~@/assets/images/202405/book-images-L.png" class="object-contain block mx-auto"></div>
            <p class="text-center pb-4 text-white">此活動專區必須選擇3個商品或是3的倍數購買<br/>例如3本、6本、9本..以此類推，滿足活動條件才享有活動優惠。</p>
            <div><img src="~@/assets/images/202405/book-images-R.png" class="object-contain block mx-auto"></div>
          </div>

          <div><p class="text-center pb-4 text-white text-xs md:hidden">此活動專區必須選擇3個商品或是3的倍數購買<br/>例如3本、6本、9本..以此類推，滿足活動條件才享有活動優惠。</p></div>

          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" v-for="(item, index) in bookData2" :key="index" class="w-1/2 md:w-1/4 item p-2" target="_blank">
              <div class="bg-white px-3 py-6 rounded-t-lg">
                <div class="outer mb-2">
                  <div class="inner mx-auto border-0 absolute w-full h-full">
                    <img :src="item.img_url" class="w-full h-full object-contain block">
                  </div>
                </div>
              </div>
              <div class="item-title text-center rounded-b-lg p-3 py-4">
                  <p class="font-semibold tracking-tighter md:tracking-tight text-xs md:text-base">{{ item.slogan }}</p>
                  <p class="text-xl font-semibold">原價<span class="price-text">{{ item.price }}</span>元</p>
                </div>
            </router-link>

          </div>

          <a href="https://store.liveabc.com/products/magazine/sale?tag=361" target="_blank" class="-mb-24 mt-6 block"><img src="~@/assets/images/202405/more-bt-wood.png" class="object-contain block mx-auto"></a>
        </div>
      </div>
      <div id="plan5" class="plan5 px-2 py-10">
        <div class="mb-24"><img src="~@/assets/images/202405/Line 8.png" class="object-contain block mx-auto"></div>

        <div class="plan5_inner container mx-auto py-4 px-2 md:px-6 pb-16">
          <div class="items-center justify-center -mt-20 hidden md:flex">
            <div><img src="~@/assets/images/202405/interativ-pic-L.png" class="object-contain block mx-auto"></div>
            <div class="px-6"><img src="~@/assets/images/202405/interativ-title-01.png" class="object-contain block mx-auto"></div>
            <div><img src="~@/assets/images/202405/interativ-pic-R.png" class="object-contain block mx-auto"></div>
          </div>
          <div class="mb-3 hidden md:block">
            <p class="text-center text-xl mb-2">※本產品僅包含電腦互動軟體，不含紙本書</p>
            <p class="text-center pb-4 leading-relaxed">1.總共可安裝於2台電腦，最多可下載安裝6次。 2.可於Windows系統（語系：繁中/英）安裝使用，Mac系統不支援。<br/>3.適用於電腦、筆電，手機或平板不支援安裝使用。</p>
          </div>
          <div class="-mt-16 md:hidden">
            <div class="px-6"><img src="~@/assets/images/202405/interativ-title-01.png" class="object-contain block mx-auto"></div>
            <div class="flex items-end">
              <div><img src="~@/assets/images/202405/interativ-pic-L.png" class="object-contain block mx-auto"></div>
              <p class="text-center pb-4 leading-relaxed text-sm md:text-base">1.總共可安裝於2台電腦，最多可下載安裝6次。 2.可於Windows系統（語系：繁中/英）安裝使用，Mac系統不支援。<br/>3.適用於電腦、筆電，手機或平板不支援安裝使用。</p>
              <div><img src="~@/assets/images/202405/interativ-pic-R.png" class="object-contain block mx-auto"></div>
            </div>
          </div>
          <div class="flex flex-wrap">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" v-for="(item, index) in bookData3" :key="index" class="w-1/2 md:w-1/4 item p-2" target="_blank">
              <div class="bg-white px-3 pt-6 pb-3 rounded-t-lg white_inner">
                <div class="outer mb-2">
                  <div class="inner mx-auto border-0 absolute w-full h-full">
                    <img :src="item.img_url" class="w-full h-full object-contain block">
                  </div>
                </div>
                <p class="text-center tracking-tighter md:tracking-tight text-sm md:text-base lg:text-xl xl:text-2xl mt-1">{{ item.slogan }}</p>
              </div>
              <div class="item-title text-center rounded-b-lg p-3 py-3">
                <p class="text-sm font-light line-through">原價{{ item.price }}元</p>
                <p class="md:text-2xl font-black">75折<span class="price-text">{{ item.new_price }}</span>元</p>
              </div>
            </router-link>

          </div>

          <a href="https://store.liveabc.com/products/magazine/sale?tag=364" target="_blank" class="-mb-24 mt-6 block"><img src="~@/assets/images/202405/more-bt-pink.png" class="object-contain block mx-auto"></a>
        </div>
      </div>
    </section>

    <section class="footer pt-10">
      <div class="container px-4 text-center font-semibold tracking-wider">
        <p class="text-xl">詳細活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</p>
      </div>
      <div class="w-full"><img src="~@/assets/images/202405/under-leaf.png" class="object-contain block mx-auto w-full h-auto"></div>
    </section>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'May2023',
  metaInfo () {
    return {
      title: '繳稅季不用怕｜LiveABC超有料書展省很大!',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      planData2: [
        { id: 7725, type: 'abc', introduction: '初級/基礎/活用', text: '打好英語基礎的最佳選擇！', class: 'w-full', img_url: require('@/assets/images/202405/m/ABC-COVER_w.png') },
        // { id: 7725, type: 'live', introduction: '中級/生活/實用', text: '日常生活實用英語輕鬆學！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/LIVE-COVER.png') },
        { id: 7727, type: 'all', introduction: '中高級/進階/應用', text: '閱讀寫作訓練豐富又多元！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/ALL-COVER.png') },
        { id: 7728, type: 'cnn', introduction: '新聞/時事/新知', text: '托福、多益檢測超必備！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/CNN-COVER.png') },
        { id: 7729, type: 'jp', introduction: '初級/生活/實用', text: '自學日語最佳輔助教材！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/JP-COVER.png') },
        { id: 7724, type: 'hiw', introduction: '圖解/百科/符合108課綱', text: '團購秒殺搶購，佳評如潮！', class: 'w-full', img_url: require('@/assets/images/202405/m/HIW-COVER.png') }
      ],
      planData: [
        { id: 7725, type: 'abc', introduction: '初級/基礎/活用', text: '打好英語基礎的最佳選擇！', class: 'w-full', img_url: require('@/assets/images/202405/m/ABC-COVER.png') },
        { id: 7726, type: 'live', introduction: '中級/生活/實用', text: '日常生活實用英語輕鬆學！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/LIVE-COVER.png') },
        { id: 7727, type: 'all', introduction: '中高級/進階/應用', text: '閱讀寫作訓練豐富又多元！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/ALL-COVER.png') },
        { id: 7728, type: 'cnn', introduction: '新聞/時事/新知', text: '托福、多益檢測超必備！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/CNN-COVER.png') },
        { id: 7729, type: 'jp', introduction: '初級/生活/實用', text: '自學日語最佳輔助教材！', class: 'w-1/2', img_url: require('@/assets/images/202405/m/JP-COVER.png') },
        { id: 7724, type: 'hiw', introduction: '圖解/百科/符合108課綱', text: '團購秒殺搶購，佳評如潮！', class: 'w-full', img_url: require('@/assets/images/202405/m/HIW-COVER.png') }
      ],
      bookData2: [
        { id: 8142, img_url: require('@/assets/images/202405/books/image 1.png'), class: '', price: 450, slogan: '類從古至今的天文發現' },
        { id: 7355, img_url: require('@/assets/images/202405/books/image 2.png'), class: '', price: 450, slogan: '探究改變世界的關鍵人事物' },
        { id: 7963, img_url: require('@/assets/images/202405/books/image 3.png'), class: '', price: 450, slogan: '集結海陸空軍事特輯' },
        { id: 8464, img_url: require('@/assets/images/202405/books/image 4.png'), class: '', price: 450, slogan: '用科學解釋你我的生活日常' },
        { id: 9440, img_url: require('@/assets/images/202405/books/image 5.png'), class: '', price: 499, slogan: '圖解單字 全家一起學' },
        { id: 7287, img_url: require('@/assets/images/202405/books/image 6.png'), class: '', price: 499, slogan: '適合零基礎的初級學習者' },
        { id: 7231, img_url: require('@/assets/images/202405/books/image 7.png'), class: '', price: 499, slogan: '西班牙語入門最佳工具書' },
        { id: 7199, img_url: require('@/assets/images/202405/books/image 8.png'), class: '', price: 499, slogan: '只學生活中用的到的單字' },
        { id: 8465, img_url: require('@/assets/images/202405/books/image 9.png'), class: '', price: 399, slogan: '從生活場景為學習出發點' },
        { id: 7219, img_url: require('@/assets/images/202405/books/image 10.png'), class: '', price: 399, slogan: '從生活場景學好英語會話' },
        { id: 7496, img_url: require('@/assets/images/202405/books/image 11.png'), class: '', price: 420, slogan: '最貼近生活的內容無痛學習' },
        { id: 6618, img_url: require('@/assets/images/202405/books/image 12.png'), class: '', price: 399, slogan: '出國時英語會聽會說能溝通' },
        { id: 6182, img_url: require('@/assets/images/202405/books/image 13.png'), class: '', price: 450, slogan: '單字拆開看 用理解代替死背' },
        { id: 6397, img_url: require('@/assets/images/202405/books/image 14.png'), class: '', price: 420, slogan: '學會句型 用英語溝通很容易' },
        { id: 5740, img_url: require('@/assets/images/202405/books/image 15.png'), class: '', price: 399, slogan: '踏穩第一步英文文法很簡單' },
        { id: 6398, img_url: require('@/assets/images/202405/books/image 16.png'), class: '', price: 420, slogan: '老師影片講解文法一點就通' },
        { id: 8926, img_url: require('@/assets/images/202405/books/image 17.png'), class: '', price: 480, slogan: '精選50篇英美及歐洲文學' },
        { id: 6032, img_url: require('@/assets/images/202405/books/image 18.png'), class: '', price: 450, slogan: '閱讀經典文學養成閱讀力' },
        { id: 7801, img_url: require('@/assets/images/202405/books/image 19.png'), class: '', price: 420, slogan: '最實用日語字彙全集中' },
        { id: 6572, img_url: require('@/assets/images/202405/books/image 20.png'), class: '', price: 380, slogan: '一張圖能記住約15個單字' }
      ],
      bookData3: [
        { id: 8934, img_url: require('@/assets/images/202405/books2/image 3.png'), class: '', price: 224, new_price: 168, slogan: '深度暢遊必遊景點' },
        { id: 8936, img_url: require('@/assets/images/202405/books2/image 4.png'), class: '', price: 224, new_price: 168, slogan: '養成英語閱讀力' },
        { id: 8744, img_url: require('@/assets/images/202405/books2/image 1.png'), class: '', price: 220, new_price: 165, slogan: '一起打造旅遊英語力' },
        { id: 8629, img_url: require('@/assets/images/202405/books2/image 2.png'), class: '', price: 220, new_price: 165, slogan: '學英語最好的題材' },
        { id: 8631, img_url: require('@/assets/images/202405/books2/image 5.png'), class: '', price: 165, new_price: 124, slogan: '讓閱讀變成一種享受' },
        { id: 8473, img_url: require('@/assets/images/202405/books2/image 6.png'), class: '', price: 220, new_price: 165, slogan: '主題包羅萬象' },
        { id: 7503, img_url: require('@/assets/images/202405/books2/image 7.png'), class: '', price: 193, new_price: 145, slogan: '12大旅遊場景' },
        { id: 7840, img_url: require('@/assets/images/202405/books2/image 8.png'), class: '', price: 193, new_price: 145, slogan: '隨時用英語提出建議' }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#May2024 {
  .bg-main {
    background: #55212D;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .outer {
    position: relative;
    width: 100%;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-Bottom: 100%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .banner {
    background-color: #FDE7EC;
    background-image: url('~@/assets/images/202405/BG.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center bottom;
    @media (max-width: 768px) {
      background-image: url('~@/assets/images/202405/m/BG.png');
      background-size: cover;
    }
    .car {
      img {
        width: 50%;
        @media (max-width: 1024px) {
          width: 70%;
        }
        @media (max-width: 768px) {
          width: 100%;
        }
      }
    }
  }
  .plan1 {
    background-image: url('~@/assets/images/202405/Pattern.png');
    background-repeat: repeat;
  }
  .plan2 {
    background: #FEF4CB;
  }
  .plan3 {
    background: #FEF4CB;
  }
  .plan4 {
    background: #FEF4CB;
    background-image: url('~@/assets/images/202405/Group.png');
    background-position: top 2% center;
    background-repeat: no-repeat;
    background-size: contain;
    @media (max-width: 1440px) {
      background-position: top 6% center;
    }
    @media (max-width: 1024px) {
      background-position: top 6% center;
    }
    @media (max-width: 768px) {
      background-position: top 5% center;
    }
    @media (max-width: 640px) {
      background-position: top 0% center;
    }
    .plan4_inner {
      background: #F35E80;
      border: 3px solid var(--W, #FFFFFF);
      box-shadow: 10px 10px 0px 0px #00000040;
      border-radius: 25px;
      p {
        font-size: 17px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0.2em;
        text-align: center;
        text-shadow: 2px 2px 0px 0px #AD380A;

      }
      .item-title {
        background: #FEF4CB;
        p {
          color: #F35E80;
        }
        .price-text {
          color: #55212D;
        }
      }
    }
  }
  .plan5 {
    background: #FEF4CB;
    p {
      color: #55212D;
    }
    .plan5_inner {
      background: #F2F2F2;
      border: 3px solid #55212D;
      box-shadow: 10px 10px 0px 0px #00000040;
      border-radius: 25px;
      p {
        font-size: 17px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0.2em;
        text-align: center;
        text-shadow: 2px 2px 0px 0px #AD380A;

      }
      .item-title {
        background: #FEF4CB;
        p {
          color: #55212D;
        }
        .price-text {
          color: #F35E80;
        }
      }
      .white_inner {
        min-height: 250px;
      }
    }
  }
  .footer {
    p {
      color: #55212D;
    }
    background: #FEF4CB;
  }
}
</style>
